// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__lmtTk","select":"Header_select__bEs4L","clinic":"Header_clinic__2YhKF"};